import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';

type CardHeaderProps = {
	name: React.ReactNode;
	badge?: React.ReactNode;
	headerActions?: React.ReactNode;
};

const styles = cssMap({
	actions: {
		pointerEvents: 'auto',
	},
});

export const CardHeader = ({ name, badge, headerActions }: CardHeaderProps): React.JSX.Element => (
	<Inline space="space.075" alignBlock="center" spread="space-between">
		<Inline space="space.075" alignBlock="center">
			<Text weight="medium" maxLines={2}>
				{name}
			</Text>
			{badge}
		</Inline>
		{headerActions ? (
			<Box as="span" xcss={styles.actions}>
				{headerActions}
			</Box>
		) : null}
	</Inline>
);
